import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {getEntityKey} from './getEntityKey'

export function getEntityKeyByEntity(entity: IResponseEntity): string {
  return getEntityKey(entity.entityType, entity.entityId)
}
